import type { AuditReport } from '@/types/gmb';
import ResultSummaryHeader from '@/pages/gmb-audit/result/components/ResultSummaryHeader';
import ScoreCard from '@/pages/gmb-audit/result/components/ScoreCard';
import PrioritySection from '@/pages/gmb-audit/result/components/PrioritySection';
import MetricsSection from '@/pages/gmb-audit/result/components/MetricsSection';
import PeerSection from '@/pages/gmb-audit/result/components/PeerSection';
import RecommendationsSection from '@/pages/gmb-audit/result/components/RecommendationsSection';
import MethodologySection from '@/pages/gmb-audit/result/components/MethodologySection';
import CtaSection from '@/pages/gmb-audit/result/components/CtaSection';
import AttributionSection from '@/pages/gmb-audit/result/components/AttributionSection';

export default function ReportView({ report }: { report: AuditReport }) {
  return (
    <div className="pb-4">
      <ResultSummaryHeader target={report.target} />
      <ScoreCard score={report.score} />
      <PrioritySection priorities={report.priorities} />
      <MetricsSection metrics={report.metrics} />
      <PeerSection comparison={report.peerComparison} peers={report.peers} />
      <RecommendationsSection recommendations={report.recommendations} />
      <MethodologySection methodology={report.methodology} />
      <CtaSection />
      <AttributionSection />
    </div>
  );
}